import React from 'react';
import _get from 'lodash/get';
import { TFunction } from 'i18next';
import { Department } from 'graphql-common';
import { CellProps } from '@lib/components/Table/types';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import UserPreviewCell from '@lib/components/Table/commonComponents/UserPreviewCell/UserPreviewCell';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';

type Args = {
  onView?: (v: Department) => void;
  t: TFunction<'translation', undefined>;
};

export default function getDepartmentsTableColumns({ onView, t }: Args) {
  return [
    {
      id: 'name',
      Header: t('department'),
      Cell: (props: CellProps<Department>) => {
        const { item } = props;
        const id = _get(item, 'id') as string;
        const label = _get(item, 'name');
        const type = colorToChipType(_get(item, 'color'));
        if (!id || !label || !type) return '-';
        return (
          <ChipCell
            label={label}
            type={type}
            leftIcon="circle"
            onClick={onView ? () => onView(item) : undefined}
          />
        );
      },
      minWidth: 260,
      maxWidth: 340,
      width: 260,
      sortable: true,
    },
    {
      id: 'membersOwnCount',
      Header: t('members-own'),
      accessor: 'membersOwnCount',
      Cell: (props: CellProps<Department>) => <TextCell {...props} />,
      maxWidth: 130,
      minWidth: 110,
      width: 110,
    },
    {
      id: 'membersTotalCount',
      Header: t('members-total'),
      accessor: 'membersTotalCount',
      Cell: (props: CellProps<Department>) => <TextCell {...props} />,
      maxWidth: 130,
      minWidth: 110,
      width: 110,
    },
    {
      id: 'tasksOwnCount',
      Header: t('tasks-own'),
      accessor: 'tasksOwnCount',
      Cell: (props: CellProps<Department>) => <TextCell {...props} />,
      maxWidth: 130,
      minWidth: 110,
      width: 110,
    },
    {
      id: 'tasksTotalCount',
      Header: t('tasks-total'),
      accessor: 'tasksTotalCount',
      Cell: (props: CellProps<Department>) => <TextCell {...props} />,
      maxWidth: 130,
      minWidth: 110,
      width: 110,
    },
    {
      id: 'manager',
      Header: t('responsible-manager'),
      Cell: ({ item }: CellProps<Department>) => {
        const { manager } = item;
        if (!manager) return <TextCell item={item} value={null} />;
        return (
          <UserPreviewCell
            avatar={
              manager.avatarAttached?.urls?.small ||
              manager.avatarAttached?.urls?.original
            }
            name={`${manager.firstName} ${manager.lastName}`}
            email={manager.email}
          />
        );
      },
      minWidth: 260,
      width: 260,
    },
  ];
}
